import React, { useState, useRef,useEffect} from "react";

import { useNavigate,useSearchParams} from "react-router-dom";
import MyCareerLogo from "../images/svg/mc-logo.svg";
import axios from "axios";
import { useRecoilState } from "recoil";
import { baseurl,environ } from "../selectors/baseurl";
import { userDataState,bearerToken } from "../atoms/dashboard";
import { Loading } from "..";
import { MycarUrl } from "../selectors/baseurl";
const Login = (props) => {
  const inputRef = useRef(null);
  const [searchParams] = useSearchParams();
  console.log(searchParams?.get('id'));
  const loginUid=searchParams?.get('id');
  const [usname, setUsnmae] = useState();
  const [, setUserData] = useRecoilState(userDataState);
  const [, setBearData] = useRecoilState(bearerToken);
  const navigate = useNavigate();
  const [islog, setIsLog] = useState(false);
  const [islogchk, setIsLogChk] = useState(false);
  const [loading, setloading] = useState(false);
  const loadingRef = useRef(null);
  useEffect(() => {
    if (loginUid)
      {
        //loadingRef.current.classList.toggle("hidden");
        loginCall();
    } else {
     
   window.location.href = MycarUrl;
    }
  },[]);

  const loginCall = async () => {
    setIsLog(true);
   /// loadingRef.current.classList.toggle("hidden");
    
    let path = "dashboard";
    let teamid = 0;
    
    try {
      //get method
    //  const URL =
    //    baseurl + `/api/login/getemployeedetails?EmployeeId=${usname}`;
    //   // console.log(URL);
    //   setIsLog(true);
    // const response = await axios.get(URL);

      //post method
     // axios.defaults.withCredentials = true
           const URL = baseurl + `/api/login/getemployeedetails`;
     const datval1= {
        "employeeId": loginUid ?loginUid:usname,
        "isEncrypted":loginUid ? 1:2
      }
      

     const response = await axios.post(URL,datval1);
  //   const response = await axios({
  //     method: 'POST',
  //     url: URL,
  //     data:datval1,
  //     headers: { "RequestVerificationToken": "CfDJ8EOI7yhiUvtCs-J9oOwlJfbcO2iL9zFq3gATgmFwyz1Sy3RcmzvIGA_4lYdYM1d61lZ_fspATxfsMR94ZLcCSZ9Qg_1hD0zq4WC4fanfC7csn59nJ8_1nFXcX-aJci76-3rvNK3aQ-dulHhjnSYRq1wZemsULGH-g6trYTvoP-9NfAYTDnLfZ3aCCIOey3mX8Q"},
  //     contentType: "application/json",
  //     dataType: "json",
  // })
    //  const response = await fetch(URL, options)
      console.log(response);

      if (response.data.response == 200) {
        console.log(response.data.employeeDetails[0]);
        setUserData(response.data.employeeDetails[0]);
        console.log(response.data.employeeDetails[0].empID);
        setIsLogChk(true);
        try {
          const PpId='rr'+response.data.employeeDetails[0].peopleSoftID;
          const URL =
              baseurl + `/Authentication/GetAuthenticationToken?username=${PpId}`;
              console.log(URL);
             setIsLog(true);
           const brearer = await axios.post(URL);
           if (brearer.request.status == 200) {
            setBearData('Bearer '+brearer.data.accessToken);
            console.log('brearer',brearer);
            navigate(path);
           }
           
        } catch (error) {
          setIsLog(false);
          setIsLogChk(false);
          console.log("Not a Valid user Error fetching data:");
          alert("Not a valid user , kindly contact admin");
        window.location.href = MycarUrl
        }
       // navigate(path);
      } else {
        setIsLog(false);
        setIsLogChk(false);
        console.log("Not a Valid user Error fetching data:");
        alert("Not a valid user , kindly contact admin");
     window.location.href = MycarUrl
      }
    } catch (error) {
      setIsLog(false);
      setIsLogChk(false);
      console.error("Error fetching data:", error);
     window.location.href = MycarUrl
    }
  };
  return (
    <>
    <div className="hidden" ref={loadingRef}><Loading /></div>
    {!islog && environ !="uat"? (<section className="bg-gray-50 dark:bg-gray-900 hidden">
      <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
        <a
          href="#"
          className="flex items-center my-4 text-2xl font-semibold text-gray-900 dark:text-white"
        >
          <img className="h-6" src={MyCareerLogo} alt="logo" />
        </a>
        <div className="w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700">
          <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
            <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
              Log in
            </h1>
            <form className="space-y-4 md:space-y-4" id="frm_submit">
               {/* <div>
                <label
                  htmlFor="email"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Employee Id
                </label>
               <input
                  type="text"
                  ref={inputRef}
                  onChange={() => setUsnmae(inputRef.current.value)}
                  name="email"
                  id="email"
                  className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="123456"
                  disabled={islog ? true : false}
                /> 
              </div>*/}

              {!islog ? (
                ""
                // <button id="Login_submit"
                //   type="button"
                //   className="w-full text-white bg-blue-600  hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
                //   onClick={loginCall}
                // >
                //   Sign in
                // </button>
              ) : (
                ""
              )}
            </form>
          </div>
        </div>
      </div>
    </section>):(<div className="visible" ref={loadingRef}><Loading /></div>)}
    </>
  );
};
export default Login;
